export default "__VITE_PUBLIC_ASSET__94fd091a__"